import { findParentWithAttribute } from '@/utils/tinyMCE/caseDetails/findParentWithAttribute'
import { ensureProperCursorPosition } from '@/utils/tinyMCE/updateDynamicText/ensureProperCursorPosition'

export const insertTemplate = (editor: Editor, content: string) => {
  if (editor) {
    replaceCaseDetailParentIfAny(editor)
    editor.execCommand('mceInsertTemplate', false, content)
    ensureProperCursorPosition(editor)
  }
}

const replaceCaseDetailParentIfAny = (editor: Editor) => {
  const selection = editor.selection
  let node
  const isSelectionValid = typeof selection?.getNode === 'function'

  if (isSelectionValid) {
    node = selection.getNode()
    const hasTextSelection = !selection.isCollapsed()

    if (hasTextSelection) {
      const dynamicParent = findParentWithAttribute(node)
      if (dynamicParent) {
        editor.dom.remove(dynamicParent)
      }
    }
  }
}
